import { render, staticRenderFns } from "./replace.vue?vue&type=template&id=16f1df37&scoped=true"
import script from "./replace.vue?vue&type=script&lang=js"
export * from "./replace.vue?vue&type=script&lang=js"
import style0 from "./replace.vue?vue&type=style&index=0&id=16f1df37&prod&lang=scss&scoped=true"
import style1 from "./replace.vue?vue&type=style&index=1&id=16f1df37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f1df37",
  null
  
)

export default component.exports